export default [{
  path: "/materialManage/storeSetting",
  name: "storeSettingIndex",
  meta: {
    title: "仓库设置",
    keepAlive: false
  },
  component: resolve =>
    require([
      "@/views/corp/materialManage/storeSettingIndex.vue"
    ], resolve)
}, {
  path: "/materialManage/inventory-consumption",
  name: "inventoryConsumption",
  meta: {
    title: "库存消耗列表",
    keepAlive: false
  },
  component: resolve =>
    require([
      "@/views/corp/materialManage/inventory-consumption/index.vue"
    ], resolve)
},
  {
    path: "/materialManage/inventory-consumption/form",
    name: "inventoryConsumptionForm",
    meta: {
      title: "库存消耗登记",
      keepAlive: false
    },
    component: resolve =>
      require([
        "@/views/corp/materialManage/inventory-consumption/form.vue"
      ], resolve)
  },
  {
    path: "/materialManage/inventory-consumption/form2",
    name: "inventoryConsumptionForm2",
    meta: {
      title: "库存消耗登记",
      keepAlive: false
    },
    component: resolve =>
      require([
        "@/views/corp/materialManage/inventory-consumption/form2.vue"
      ], resolve)
  },
  {
    path: "/materialManage/inventory-consumption/detail",
    name: "inventoryConsumptionDetail",
    meta: {
      title: "库存消耗详情",
      keepAlive: false
    },
    component: resolve =>
      require([
        "@/views/corp/materialManage/inventory-consumption/detail.vue"
      ], resolve)
  },
  {
    path: "/materialManage/inventory-consumption/confirmForm",
    name: "inventoryConsumptionConfirmForm",
    meta: {
      title: "库存消耗确认",
      keepAlive: false
    },
    component: resolve =>
      require([
        "@/views/corp/materialManage/inventory-consumption/confirmForm.vue"
      ], resolve)
  },
  {
    path: "/materialManage/inventory-consumption/confirmDetail",
    name: "inventoryConsumptionConfirmDetail",
    meta: {
      title: "库存消耗确认详情",
      keepAlive: false
    },
    component: resolve =>
      require([
        "@/views/corp/materialManage/inventory-consumption/confirmDetail.vue"
      ], resolve)
  },
  {
    path: "/materialManage/material-transfer/index",
    name: "materialTransferIndex",
    meta: {
      title: "调拨管理",
      keepAlive: false
    },
    component: resolve =>
      require([
        "@/views/corp/materialManage/material-transfer/index.vue"
      ], resolve)
  },
  {
    path: "/materialManage/material-transfer/outForm",
    name: "materialTransferOutForm",
    meta: {
      title: "出库确认",
      keepAlive: false
    },
    component: resolve =>
      require([
        "@/views/corp/materialManage/material-transfer/outForm.vue"
      ], resolve)
  },
  {
    path: "/materialManage/material-transfer/receiveForm",
    name: "materialTransferReceiveForm",
    meta: {
      title: "收货确认",
      keepAlive: false
    },
    component: resolve =>
      require([
        "@/views/corp/materialManage/material-transfer/receiveForm.vue"
      ], resolve)
  },
  //调拨异常处理
  {
    path: "/materialManage/material-transfer/abnormalForm",
    name: "materialTransferAbnormalForm",
    meta: {
      title: "异常处理",
      keepAlive: false
    },
    component: resolve =>
      require([
        "@/views/corp/materialManage/material-transfer/abnormalForm.vue"
      ], resolve)
  },
  {
    path: "/materialManage/material-transfer/detail",
    name: "materialTransferDetail",
    meta: {
      title: "调拨详情",
      keepAlive: false
    },
    component: resolve =>
      require([
        "@/views/corp/materialManage/material-transfer/detail.vue"
      ], resolve)
  },
  {
    path: "/materialManage/stock-transfer/index",
    name: "stockTransferIndex",
    meta: {
      title: "库存转储",
      keepAlive: false
    },
    component: resolve =>
      require([
        "@/views/corp/materialManage/stock-transfer/index.vue"
      ], resolve)
  },
  {
    path: "/materialManage/stock-transfer/detail",
    name: "stockTransferDetail",
    meta: {
      title: "库存转储详情",
      keepAlive: false
    },
    component: resolve =>
      require([
        "@/views/corp/materialManage/stock-transfer/detail.vue"
      ], resolve)
  },
  {
    path: "/materialManage/stock-transfer/receiveForm",
    name: "stockTransferReceiveForm",
    meta: {
      title: "库存转储收货确认",
      keepAlive: false
    },
    component: resolve =>
      require([
        "@/views/corp/materialManage/stock-transfer/receiveForm.vue"
      ], resolve)
  },
  //转储异常处理
  {
    path: "/materialManage/stock-transfer/abnormalForm",
    name: "stockTransferAbnormalForm",
    meta: {
      title: "异常处理",
      keepAlive: false
    },
    component: resolve =>
      require([
        "@/views/corp/materialManage/stock-transfer/abnormalForm.vue"
      ], resolve)
  },
  //物料退料
  {
    path: '/materialManage/material-return/index',
    meta: {title: '物料退料'},
    component: () => import('@/views/corp/materialManage/material-return/index.vue')
  },
  {
    path: '/materialManage/material-return/form',
    meta: {title: '物料退料表单'},
    component: () => import('@/views/corp/materialManage/material-return/form.vue')
  },
  {
    path: '/materialManage/material-return/detail',
    meta: {title: '物料退料详情'},
    component: () => import('@/views/corp/materialManage/material-return/detail.vue')
  },
  //物料退料确认
  {
    path: '/materialManage/material-return-confirm/index',
    meta: {title: '物料退料确认'},
    component: () => import('@/views/corp/materialManage/material-return-confirm/index.vue')
  },
  {
    path: '/materialManage/material-return-confirm/form',
    meta: {title: '退料确认表单'},
    component: () => import('@/views/corp/materialManage/material-return-confirm/form.vue')
  },
  {
    path: '/materialManage/material-return-confirm/detail',
    meta: {title: '物料退料详情'},
    component: () => import('@/views/corp/materialManage/material-return-confirm/detail.vue')
  },
  //物料退库
  {
    path: '/materialManage/stock-return/index',
    meta: {title: '物料退库'},
    component: () => import('@/views/corp/materialManage/stock-return/index.vue')
  },
  {
    path: '/materialManage/stock-return/form',
    meta: {title: '物料退库表单'},
    component: () => import('@/views/corp/materialManage/stock-return/form.vue')
  },
  {
    path: '/materialManage/stock-return/detail',
    meta: {title: '物料退库详情'},
    component: () => import('@/views/corp/materialManage/stock-return/detail.vue')
  },
]



// WEBPACK FOOTER //
// ./src/router/other.js